import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Divider,
} from '@mui/material'
import { AttributeGroup } from '../../ShedManagementTypes'
import {
  useCallback, useEffect, useRef, useState,
} from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ShedManagementState'

interface GenericRadioGroupProps {
  attributeGroup: AttributeGroup
}

enum ConversionGroupNames {
  Type = 'Tipo',
  Function = 'Função',
  Storage = 'Armazenagem'
}

const ConversionPropertyNames: Record<ConversionGroupNames, string> = {
  [ConversionGroupNames.Type]: 'idAttributeType',
  [ConversionGroupNames.Function]: 'idAttributeFunction',
  [ConversionGroupNames.Storage]: 'idAttributeStorage',
}

const GenericRadioGroup = ({
  attributeGroup,
}: GenericRadioGroupProps) => {
  const [selectedOption, setSelectedOption] = useState<number | null>(null)
  const { selectedProducts } = useSelector((state) => state.shedManagement)
  const dispatch = useDispatch()
  const propertyRef = useRef('')

  useEffect(() => {
    Object.entries(ConversionPropertyNames).forEach(([key, value]) => {
      if (key === attributeGroup.groupName) {
        propertyRef.current = value
      }
    })
  }, [attributeGroup])

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const propertyToChange = event.target.name
    const { value } = event.target as HTMLInputElement
    setSelectedOption(Number(value))
    const updatedSelectedProducts = selectedProducts.map((product) => ({
      ...product,
      [propertyToChange]: Number(value),
    }))

    dispatch(actions.setSelectedProducts({ selectedProducts: updatedSelectedProducts }))
  }, [dispatch, selectedProducts])

  useEffect(() => {
    if (selectedProducts.length > 0) {
      const propertyValue = selectedProducts[0][`${propertyRef.current}`]
      const allHaveSameAttribute = selectedProducts.every((product) => product[`${propertyRef.current}`] === propertyValue)

      if (allHaveSameAttribute) {
        setSelectedOption(propertyValue)
      } else {
        setSelectedOption(null)
      }
    } else {
      setSelectedOption(null)
    }
  }, [selectedOption, selectedProducts])

  return (
    <FormControl>
      <Typography sx={{ padding: '0 0 0 .8rem' }}>{attributeGroup.groupName}</Typography>
      <Divider flexItem variant='middle'/>
      <RadioGroup
        name={propertyRef.current}
        value={selectedOption}
        onChange={handleChange}
        row
        sx={{
          padding: '0 0 0 .8rem',
        }}
      >
        {attributeGroup.values.map((item) => (
          <FormControlLabel
            key={item.id}
            disabled={selectedProducts.length < 1}
            value={item.id}
            control={<Radio />}
            label={item.name}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default GenericRadioGroup
